module.exports = __webpack_public_path__ + "static/fonts/Avenir_LT_65_Medium.f834452d.woff2";